
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-watch",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-watch"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"i-watch__eye",attrs:{"d":"M15.78 9S13.52 5 9 5 2.22 9 2.22 9A8.32 8.32 0 009 13a8.32 8.32 0 006.78-4z"}}),_c('circle',{staticClass:"i-watch__iris",attrs:{"cx":"9","cy":"9","r":"2.15"}}),_c('circle',{staticClass:"i-watch__pupil",attrs:{"cx":"9","cy":"9","r":".1","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    